'use strict';

app.config(function ($stateProvider) {

  $stateProvider.state('instance.app.module.lesson.byte', {
    url: '/byte/:byteId',
    resolve: {
      byte: function ($q, lesson, $stateParams) {
        return _.find(lesson.learningBytes, { _id: $stateParams.byteId }) || $q.reject({ status: 404 });
      }
    },
    templateUrl: '/app/states/module/lesson/byte/byte.html',
    controller: function ($scope, $state, $q, $stateParams, Api, module, lesson, byte, Documents, rmGuide) {
      $scope.showTutorial = _.get($scope.instance, 'tutorial.enabled', false);
      $scope.isTutorialViewed = function (id) {
        return rmGuide.isViewed(id);
      };
      $scope.onNotificationDismiss = function () {
        rmGuide.markViewed($scope.byte.tutorial.id);
      };
      Api.track('module.lesson.byte', 'view');

      $scope.byte = byte;
      lesson.activeByte = byte;

      var fromPostQuiz = $scope.$root.fromPostQuiz;
      delete $scope.$root.fromPostQuiz;

      var minorLabels = {
        tips: 'Tips',
        related: 'Related',
        legends: 'Myths / Legends / Statistics',
        dosdonts: 'Dos & Don\'ts'
      };

      byte.majors.forEach(function (major) {
        // restore forms fields from history
        if (major.layout == 'form') {
          _.forEach(major.savedFormData, function (field) {
            if (!field) {
              //@TODO We need to fix missing _id field in old form data
              return;
            }
            var formField = _.find(major.data.form.fields, {_id: field._id});
            if (!formField) { return; }
            if (formField.type == 'checkbox') {
              _.forEach(formField.values, function (value) {
                value.selected = _.contains(field.selected, value._id);
              });
            } else {
              _.extend(formField, field);
            }
          });
        }
        //
        var inlineIndex = 1;
        major.minors.forEach(function (minor) {
          minor.label = minorLabels[minor.type];
          minor.href = major.type + '-' + minor.type;
          if (minor.type === 'inline') {
            minor.href += '-' + inlineIndex++;
          }
        });
      });

      var formToDoc = function (major) {
        var formData = major.data.form;
        var docName = module.name + ' Module → ' + lesson.name + ' → ' + byte.name + ' → ' + formData.fields[0].value;
        return {
          name: docName,
          sourceType: 'form',
          sourceParams: angular.extend({}, $stateParams, {
            instanceId: $scope.instance._id,
            major: major.type,
            byteName: byte.name
          }),
          form: formData
        };
      };

      $scope.next = function () {
        var documents = [];
        var meta = {};
        // save forms state to meta for history
        var majorForms = _.filter(byte.majors, { layout: 'form' });
        if (majorForms.length) {
          meta.forms = {};
          _.forEach(majorForms, function (major) {
            meta.forms[major.type] = _.map(major.data.form.fields, function (field) {
              var stash = {_id: field._id};
              if (field.type == 'checkbox') {
                stash.selected = _(field.values).filter('selected').pluck('_id').value();
              } else if (field.type == 'dropdown' || field.type == 'radio') {
                // adjust data for pdf creator
                field.value = field.selected && field.selected.text;
                _.forEach(field.values, function (val) { val.selected = false; });
                if (field.selected) { field.selected.selected = true; }
                //
                stash.default = _.indexOf(field.values, field.selected);
              } else if (field.type == 'date') {
                stash.default = 'custom';
                stash.date = field.value;
              } else {
                stash.default = field.value;
              }
              return stash;
            });
          });
          documents = _.map(majorForms, formToDoc);
        }

        $q.all([
          Api.track('module.lesson.byte', 'pass', {}, meta),
          //Don't call save docs if no docs were created on the page :)
          documents.length ? Documents.saveMultiple(documents) : true
        ])
          .then(function () {
            if (fromPostQuiz) {
              $state.go('^.^.quiz.results', { quizType: 'post' });
              return;
            }
            var next = lesson.learningBytes[byte.index];
            if (next) {
              $state.go('^.byte', { byteId: next._id }, { reload: true });
            } else {
              $state.go('^.recap', {}, { reload: true });
            }
          });
      };

      byte.majors.forEach(function (major) {
        if (major.layout == 'form' && !major.initialFormData) {
          major.initialFormData = [];
          angular.copy(major.data.form.fields, major.initialFormData);
        }
      });
      $scope.getFormData = function (major) {
        return major.data.form.fields;
      };
      $scope.resetFormData = function (major) {
        angular.copy(major.initialFormData, major.data.form.fields);
        $scope.byteForm.$setPristine();
      };
      $scope.atLeastOneSelected = function (values) {
        return _.filter(values, 'selected').length > 0;
      };
      $scope.today = function () {
        return new Date();
      };

    }
  });

});
